import { render, staticRenderFns } from "./PToast.vue?vue&type=template&id=fb6e3df2&scoped=true&"
import script from "./PToast.vue?vue&type=script&lang=js&"
export * from "./PToast.vue?vue&type=script&lang=js&"
import style0 from "./PToast.vue?vue&type=style&index=0&id=fb6e3df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6e3df2",
  null
  
)

export default component.exports